import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

export function AuthLoading() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress size={48} />
    </Box>
  );
}

const AuthRequired = ({ message = 'Error de autorización.' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        p: 3,
      }}
    >
      <Box
        sx={{
          p: 4,
          maxWidth: 560,
          textAlign: 'center',
          borderRadius: '10px',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Typography variant="h3" component="h1" sx={{ mb: 2, fontWeight: 700 }}>
          No autorizado
        </Typography>
        <Typography variant="h6" component="p" sx={{ opacity: 0.9 }}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthRequired;
